import { makeStyles } from '@mui/styles'
import classNames from 'classnames'
import { newThemeObject } from '../../newTheme'
import { tokens } from '../../styles/tokens'

const useStyles = makeStyles(theme => ({
  wrapper: {
    borderRadius: newThemeObject.roundness.basic,
    backgroundColor: tokens.color.white,
    boxShadow: tokens.shadow.sm,
    padding: '16px',
    gap: theme.spacing(1),
  },
}))

interface CardWrapperProps {
  children: React.ReactNode
  className?: string
}

const CardWrapper: React.FC<CardWrapperProps> = ({ children, className }) => {
  const classes = useStyles()
  return <div className={classNames(classes.wrapper, className)}>{children}</div>
}

export default CardWrapper
